// extracted by mini-css-extract-plugin
export default {"Dots":"Carousel_Dots__SKWFI","DotsFocus":"Carousel_DotsFocus__5ATUF"};